import React, { useState, useEffect } from "react";
import {
  FiList,
  FiFlag,
  FiArrowLeft,
  FiArrowRight,
  FiCheckCircle,
  FiUpload,
} from "react-icons/fi";
import { IoStar } from "react-icons/io5";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEraser } from "react-icons/fa";
import TestHeader from "./TestHeader";
import { axiosRequest } from "../../../_config/apiClient";
import { showError, showSuccess } from "../../../_config/toastUtil";
import { ToastContainer } from "react-toastify";
import PauseModal from "./modal/PauseModal";
import SubmitYourTestModal from "./modal/SubmitYourTestModal";

const SESSION_KEYS = {
  PAUSED: "exam_paused",
  RESUME_HIT: "exam_resume_hit",
  SECONDS: "exam_seconds",
  CURRENT_Q: "exam_current_q",
  QUESTIONS_STATE: "exam_questions_state",
};

const TestInterface = () => {
  const navigate = useNavigate();
  const { state } = useLocation() || {};
  const { targetType, targetId, sessionId } = state || {};
  const examConfig = JSON.parse(sessionStorage.getItem("examConfig")) || {};

  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [submitRows, setSubmitRows] = useState([]);
  const [submitTitle, setSubmitTitle] = useState("");

  const [questions, setQuestions] = useState([]);
  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [loadingQuestions, setLoadingQuestions] = useState(true);

  const [seconds, setSeconds] = useState(null);
  const [isRunning, setIsRunning] = useState(true);
  const [autoSubmitted, setAutoSubmitted] = useState(false);

  const [showPauseModal, setShowPauseModal] = useState(false);

  const isPaused = !isRunning;

  // AUTO MARK VISITED
  useEffect(() => {
    if (!questions.length) return;

    const updated = [...questions];
    const q = updated[currentQIndex];

    if (q.status === "not_visited") {
      q.status = "not_answered";
      setQuestions(updated);
    }
  }, [currentQIndex]);


  const loadExamData = async () => {
    try {
      setLoadingQuestions(true);

      const normalRes = await axiosRequest(
        "post",
        "/user/getExamQuestions",
        { sourceId: targetId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        }
      );

      const normalList = normalRes.data.list;

      let answerMap = {};

      if (examConfig?.status === "paused") {


        const pausedRes = await axiosRequest(
          "post",
          "/user/getResultTest",
          {
            attemptId: sessionId,
          },
          {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          }
        );

        const resumeAlreadyHit = sessionStorage.getItem(SESSION_KEYS.RESUME_HIT);

        if (!resumeAlreadyHit && examConfig?.status === "paused") {
          let res = await axiosRequest(
            "post",
            "/user/togglePauseExamAttempt",
            { attemptId: sessionId },
            {
              Authorization: `Bearer ${localStorage.getItem("user")}`,
            }
          );
          sessionStorage.setItem(SESSION_KEYS.RESUME_HIT, "true");
        }

        const pausedData = pausedRes.data;
        console.log('pausedData', pausedData);

        const usedSeconds = pausedData.time?.remainingSeconds || 0;

        console.log('usedSeconds', usedSeconds);

        setSeconds(usedSeconds);
        setIsRunning(usedSeconds > 0);


        pausedData.sectionWise?.forEach(section => {
          section.questions?.forEach(q => {
            answerMap[q.questionId] = {
              selectedOption: q.selectedOption,
              markForReview: q.isMarkedForReview,
              isSubmitted: q.isSubmitted
            };
          });
        });
      }

      const flatQuestions = [];
      const dynamicTabs = [];
      let currentGlobalCount = 0;

      normalList.forEach((section) => {
        const sectionStart = currentGlobalCount;

        section.questions.forEach((q) => {

          const saved = answerMap[q._id];

          flatQuestions.push({
            id: q._id,
            questionNo: q.questionNo,
            questionType: q.questionType,
            optionsType: q.optionsType,
            questionText: q.questionText,

            sectionParagraph:
              section.paragraph?.isParagraph
                ? section.paragraph.text
                : null,

            difficulty: q.difficulty || "moderate",
            sectionId: section._id,
            sectionName: section.sectionName,
            options: Object.entries(q.options).map(([key, value]) => ({
              id: key,
              value: value,
            })),

            selectedOption: saved?.selectedOption || null,
            isMarkedForReview: saved?.markForReview || false,
            isSubmitted: !!saved,

            status: saved
              ? saved.markForReview
                ? saved.selectedOption
                  ? "marked_answered"
                  : "marked"
                : saved.selectedOption
                  ? "answered"
                  : "not_answered"
              : "not_visited",
          });

          currentGlobalCount++;
        });

        dynamicTabs.push({
          label: `${section.sectionName} (${sectionStart + 1}-${currentGlobalCount})`,
          title: section.sectionName,
          start: sectionStart,
          end: currentGlobalCount,
        });
      });

      setQuestions(flatQuestions);
      setTabs(dynamicTabs);

      if (examConfig?.status === "paused") {
        const lastAnsweredIndex = flatQuestions
          .map((q, idx) => q.selectedOption ? idx : null)
          .filter(v => v !== null)
          .pop();

        if (lastAnsweredIndex !== undefined) {
          setCurrentQIndex(lastAnsweredIndex);
        }

      } else {
        const durationInMinutes = examConfig?.durationMinutes || 60;
        setSeconds(durationInMinutes * 60);
        setIsRunning(true);
      }


    } catch (err) {
      console.error("Exam load error", err);
    } finally {
      setLoadingQuestions(false);
    }
  };



  useEffect(() => {
    loadExamData();
  }, []);


  const currentQ = questions[currentQIndex] || {};

  const handleOptionSelect = (optId) => {
    if ((currentQ.isSubmitted && !currentQ.isMarkedForReview) || isPaused) return;

    const updated = [...questions];
    updated[currentQIndex].selectedOption = optId;
    setQuestions(updated);
  };


  const handlePrevious = () => {
    if (currentQIndex > 0) setCurrentQIndex(currentQIndex - 1);
  };

  const handleClear = () => {
    if (currentQ.isSubmitted) return;

    const updated = [...questions];
    updated[currentQIndex].selectedOption = null;
    updated[currentQIndex].status = "not_answered";
    setQuestions(updated);
  };

  const handlePaletteClick = (idx) => {
    setCurrentQIndex(idx);
  };

  const saveAnswerToServer = async (questionObj) => {
    try {
      const payload = {
        attemptId: sessionId,
        questionId: questionObj.id,
        sectionId: questionObj.sectionId,
        sectionName: questionObj.sectionName,
        selectedOption: questionObj.selectedOption,
        markForReview: questionObj.markForReview || false
      };

      const res = await axiosRequest("post", "/user/saveAnswer", payload, {
        Authorization: `Bearer ${localStorage.getItem("user")}`,
      });
      console.log(`Question ${questionObj.questionNo} saved.`);
      return res?.error === false;
    } catch (err) {
      showError(err.message || "Error saving answer. Please try again.");
      console.error("Error saving answer", err);
      return false;
    }
  };

  const handleNext = async () => {
    const updatedQuestions = [...questions];
    const q = updatedQuestions[currentQIndex];

    if (q.isMarkedForReview) {
      const saved = await saveAnswerToServer({
        ...q,
        markForReview: true,
      });

      if (!saved) return;

      q.isMarkedForReview = false;   // 🔒 lock again
      q.isSubmitted = true;
    }

    else if (!q.isSubmitted) {
      q.status = q.selectedOption ? "answered" : "not_answered";

      const saved = await saveAnswerToServer({
        ...q,
        markForReview: false,
      });

      if (!saved) return;

      q.isSubmitted = true;
    }

    setQuestions(updatedQuestions);

    if (currentQIndex < questions.length - 1) {
      setCurrentQIndex(prev => prev + 1);
    } else {
      await finalSubmitExam();
    }
  };

  const confirmPause = async () => {
    setShowPauseModal(false);
    await togglePauseExam();
  };

  const cancelPause = () => {
    setShowPauseModal(false);
  };

  useEffect(() => {
    if (!tabs.length) return;

    const newActiveTab = tabs.findIndex(
      (tab) =>
        currentQIndex >= tab.start && currentQIndex < tab.end
    );

    if (newActiveTab !== -1 && newActiveTab !== activeTab) {
      setActiveTab(newActiveTab);
    }
  }, [currentQIndex, tabs]);

  useEffect(() => {
    sessionStorage.setItem(SESSION_KEYS.CURRENT_Q, currentQIndex);
  }, [currentQIndex]);

  useEffect(() => {
    const savedPaused = JSON.parse(
      sessionStorage.getItem(SESSION_KEYS.PAUSED)
    );

    const savedSeconds = sessionStorage.getItem(SESSION_KEYS.SECONDS);
    const savedQ = sessionStorage.getItem(SESSION_KEYS.CURRENT_Q);

    if (savedSeconds !== null) {
      setSeconds(Number(savedSeconds));
    } else if (examConfig?.durationMinutes) {
      setSeconds(examConfig.durationMinutes * 60);
    }

    if (savedPaused === true) {
      setIsRunning(false);
    } else if (savedPaused === false) {
      setIsRunning(true);
    }


    if (savedQ !== null) {
      setCurrentQIndex(Number(savedQ));
    }
  }, []);

  const handleReview = async () => {
    const updatedQuestions = [...questions];
    const q = updatedQuestions[currentQIndex];

    // 🔓 Enable review mode
    q.isMarkedForReview = true;

    // status update
    q.status = q.selectedOption
      ? "marked_answered"
      : "marked";

    // Save with markForReview true
    const saved = await saveAnswerToServer({
      ...q,
      markForReview: true,
    });

    if (!saved) {
      showError("Unable to mark review");
      return;
    }

    setQuestions(updatedQuestions);
  };

  const finalSubmitExam = async () => {
    try {
      setIsRunning(false);

      await axiosRequest(
        "post",
        "/user/submitExamAttempt",
        { attemptId: sessionId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      showSuccess("Exam submitted successfully!");
      sessionStorage.removeItem(SESSION_KEYS.RESUME_HIT);
      sessionStorage.removeItem(SESSION_KEYS.SECONDS);
      sessionStorage.removeItem(SESSION_KEYS.CURRENT_Q);
      sessionStorage.removeItem(SESSION_KEYS.QUESTIONS_STATE);
      navigate("/test-result", { state: { attemptId: sessionId } });
    } catch (err) {
      showError("Error submitting exam. Please try again.");
      console.error("Final submit error", err);
      setIsRunning(true);
    }
  };

  const togglePauseExam = async () => {
    try {
      let res = await axiosRequest(
        "post",
        "/user/togglePauseExamAttempt",
        { attemptId: sessionId },
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        }
      );
      console.log('hello', res);
      if (res.error === false) {
        setIsRunning(false);

        sessionStorage.removeItem(SESSION_KEYS.RESUME_HIT);
        sessionStorage.removeItem(SESSION_KEYS.SECONDS);
        sessionStorage.removeItem(SESSION_KEYS.CURRENT_Q);
        sessionStorage.removeItem(SESSION_KEYS.QUESTIONS_STATE);
        showSuccess("Exam paused successfully");

        navigate("/dashboard");
      } else {
        showError(res.message || "Unable to pause exam");
      }
    } catch (err) {
      showError(err.message || "Unable to pause/resume exam");
      console.error("Pause exam error", err);
    }
  };


  useEffect(() => {
    if (!isRunning || seconds === null || seconds === 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => {
        const next = prev - 1;
        sessionStorage.setItem(SESSION_KEYS.SECONDS, next);
        return next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isRunning, seconds]);

  useEffect(() => {
    if (seconds !== 0 || autoSubmitted) return;

    const submitWithSave = async () => {
      setAutoSubmitted(true);

      const q = questions[currentQIndex];
      if (q && !q.isSubmitted) {
        await saveAnswerToServer(q);
      }

      if (targetType === "Exam") {
        await finalSubmitExam();
      }
    };

    submitWithSave();
  }, [seconds]);


  useEffect(() => {
    if (seconds !== 0) return;

    if (targetType === "Exam") {
      finalSubmitExam("test");
    } else {
      showSuccess("Practice time completed");
      setIsRunning(false);
    }
  }, [seconds]);

  const getSectionStats = (onlySectionId = null) => {
    const sectionMap = {};

    questions.forEach(q => {
      if (onlySectionId && q.sectionId !== onlySectionId) return;

      if (!sectionMap[q.sectionId]) {
        sectionMap[q.sectionId] = {
          section: q.sectionName,
          total: 0,
          answered: 0,
          notAnswered: 0,
          review: 0,
          notVisited: 0
        };
      }

      const s = sectionMap[q.sectionId];
      s.total++;

      if (q.status === "answered") s.answered++;
      else if (q.status === "not_answered") s.notAnswered++;
      else if (q.status === "marked" || q.status === "marked_answered") s.review++;
      else if (q.status === "not_visited") s.notVisited++;
    });

    return Object.values(sectionMap);
  };

  const handleSectionSubmit = async () => {
    setShowSubmitModal(false);

    const currentSectionId = currentQ.sectionId;

    const sectionQuestions = questions.filter(
      q => q.sectionId === currentSectionId
    );

    // 🔥 SAVE ALL UNSUBMITTED QUESTIONS FIRST
    for (let q of sectionQuestions) {
      if (!q.isSubmitted) {
        await saveAnswerToServer({
          ...q,
          selectedOption: q.selectedOption || null,
          markForReview: q.isMarkedForReview || false,
        });
      }
    }

    // 🔒 Lock section in frontend
    const updated = questions.map(q =>
      q.sectionId === currentSectionId
        ? { ...q, isSubmitted: true }
        : q
    );

    setQuestions(updated);

    const currentTabIndex = tabs.findIndex(
      tab =>
        currentQIndex >= tab.start &&
        currentQIndex < tab.end
    );

    const nextTab = tabs[currentTabIndex + 1];

    if (nextTab) {
      setCurrentQIndex(nextTab.start);
      setActiveTab(currentTabIndex + 1);
    } else {
      const rows = getSectionStats();
      setSubmitRows(rows);
      setSubmitTitle("Submit Full Test");
      setShowSubmitModal(true);
      return;
    }

    showSuccess("Section submitted successfully");
  };


  if (loadingQuestions)
    return <div className="p-10 text-center">Loading Questions...</div>;

  return (
    <div className="flex flex-col bg-[#F5F7FA] font-sans text-[#333] min-h-screen">
      <ToastContainer />
      <TestHeader
        secondsLeft={seconds}
        onPause={() => {
          if (isRunning) {
            setShowPauseModal(true);
          } else {
            togglePauseExam();
          }
        }}
        isRunning={isRunning}
        testName={examConfig.testName}
        testMeta={`${tabs.length} Sections | ${questions.length} Questions`}
      />

      <PauseModal
        isOpen={showPauseModal}
        onNo={cancelPause}
        onYes={confirmPause}
      />

      <SubmitYourTestModal
        isOpen={showSubmitModal}
        onClose={() => setShowSubmitModal(false)}
        onSubmit={() => {
          if (submitTitle.includes("Section")) {
            handleSectionSubmit();
          } else {
            finalSubmitExam();
          }
        }}
        title={submitTitle}
        rows={submitRows}
        timeLeft={`${Math.floor(seconds / 60)} Min ${seconds % 60} Sec`}
      />


      <div className="max-w-[1400px] mx-auto px-3 py-4 w-full">
        <div className="lg:flex gap-5">
          {/* LEFT SIDE: QUESTION AREA */}
          <div className="flex-1 flex flex-col bg-white rounded-[10px] shadow-sm border border-[#E0E0E0] overflow-hidden">
            <div className="flex flex-col gap-[16px] px-[24px] py-[20px] bg-[#D7EAFF] border-b border-[#333]">
              <h2 className="text-[22px] font-[500] text-[#333]">
                {currentQ.sectionName}
              </h2>
              <div className="flex flex-wrap items-center gap-4 text-[16px] font-[500] text-[#333]">
                <div className="flex items-center gap-1">
                  <IoStar size={20} />
                  <span
                    className={`capitalize ${currentQ.difficulty === "easy"
                      ? "text-green-600"
                      : currentQ.difficulty === "hard"
                        ? "text-red-600"
                        : "text-yellow-600"
                      }`}
                  >
                    Difficulty: {currentQ.difficulty || "moderate"}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <FiList size={20} /> Question {currentQIndex + 1} of{" "}
                  {questions.length}
                </div>
              </div>
            </div>

            {/* SECTION PARAGRAPH */}
            {currentQ.sectionParagraph && (
              <div className="mb-8 p-6 rounded-b-xl rounded-0  bg-[#F0F7FF] border border-[#B6D4FE]">
                <div className="text-[12px] font-bold uppercase tracking-widest text-[#2563EB] mb-3">
                  Passage
                </div>

                <div
                  className="prose prose-lg max-w-none text-[#1F2937]
                  prose-img:rounded-lg
                  prose-img:shadow
                  prose-img:max-h-[400px]"
                  dangerouslySetInnerHTML={{
                    __html: currentQ.sectionParagraph,
                  }}
                />
              </div>
            )}


            <div className="flex-1 px-6 py-5">
              <h3 className="text-[20px] font-[500] text-[#333] mb-8 leading-tight">
                <span className="font-semibold mr-2">
                  Q.{currentQ.questionNo}.
                </span>

                {currentQ.questionType === "paragraph" ? (
                  <div
                    className="prose prose-lg max-w-none space-y-3"
                    dangerouslySetInnerHTML={{
                      __html: currentQ.questionText,
                    }}
                  />
                ) : (
                  <span>{currentQ.questionText}</span>
                )}
              </h3>


              <div className="space-y-[16px] max-w-4xl my-[50px]">
                {currentQ.options?.map((opt) => (
                  <div
                    key={opt.id}
                    onClick={() => handleOptionSelect(opt.id)}
                    className={`flex items-center p-[10px] rounded-[8px] border cursor-pointer
      ${currentQ.isSubmitted ? "opacity-60 cursor-not-allowed" : ""}
    `}
                  >
                    <div
                      className={`w-[38px] h-[38px] rounded-full flex items-center justify-center font-[500] mr-8 text-[20px]
        ${currentQ.selectedOption === opt.id
                          ? "bg-[#E63946] text-white"
                          : "bg-[#F3F4F6] text-[#33333399]"
                        }`}
                    >
                      {opt.id}
                    </div>

                    {currentQ.optionsType === "image" ? (
                      <img
                        src={opt.value}
                        alt={`Option ${opt.id}`}
                        className="max-h-[120px] rounded-lg border object-contain"
                      />
                    ) : (
                      <span className="text-[20px] text-[#33333399] font-[500]">
                        {opt.value}
                      </span>
                    )}
                  </div>

                ))}
              </div>
            </div>

            <div className="px-6 py-5 md:py-10 border-t border-[#33333380] bg-white">
              <div className="flex flex-wrap  justify-center items-center md:justify-between gap-3">
                <button
                  onClick={handlePrevious}
                  disabled={currentQIndex === 0}
                  className="flex items-center w-full md:w-auto justify-center gap-2 h-[44px] px-10 border border-[#33333380] rounded-[6px] disabled:opacity-50"
                >
                  <FiArrowLeft /> Previous
                </button>
                <div className="flex flex-wrap gap-3">
                  <button
                    onClick={handleClear}
                    className="flex items-center gap-2 h-[44px] px-5 border border-[#333] rounded-[6px]"
                  >
                    <FaEraser /> Clear
                  </button>
                  <button
                    onClick={handleReview}
                    className="flex items-center gap-2 h-[44px] px-5 bg-[#F97316] text-white rounded-[6px]"
                  >
                    <FiFlag /> Review
                  </button>
                </div>
                <button
                  onClick={handleNext}
                  className="flex items-center w-full md:w-auto justify-center gap-2 h-[44px] px-10 bg-[#4096F6] text-white rounded-[6px]"
                >
                  {currentQIndex === questions.length - 1 ? "Submit" : "Next"}{" "}
                  <FiArrowRight />
                </button>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE: PALETTE */}
          <div className="lg:w-[416px] bg-white mt-4 lg:mt-0 shadow-sm border border-[#E0E0E0] rounded-[12px] flex flex-col h-fit">
            <div className="px-5 py-4 bg-[#D7EAFF] rounded-t-[12px]">
              <h3 className="font-[500] text-[22px]">Question Palette</h3>
            </div>

            <div className="flex text-[12px] border-b border-[#33333366] overflow-x-auto no-scrollbar">
              {tabs.map((tab, idx) => (
                <div
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-3 cursor-pointer whitespace-nowrap ${activeTab === idx ? "border-b-2 border-[#FA0000] text-[#FA0000]" : ""}`}
                >
                  {tab.label}
                </div>
              ))}
            </div>

            <div className="p-4 grid grid-cols-6 md:grid-cols-9 lg:grid-cols-6 xl:grid-cols-6 gap-3">
              {questions
                .slice(tabs[activeTab]?.start, tabs[activeTab]?.end)
                .map((q, i) => {
                  const globalIdx = tabs[activeTab].start + i;
                  const isCurrent = globalIdx === currentQIndex;

                  // let style = "bg-[#F2EAEA] border-[#33333366] text-[#333333]";
                  // if (q.status === "answered")
                  //   style = "bg-[#FDCECE] border-[#E6394687] text-[#E63946]";
                  // if (q.status === "marked")
                  //   style = "bg-[#F2EAEA] border-[#EAB308] text-[#854D0E]";
                  // if (isCurrent)
                  //   style =
                  //     "bg-[#FDCECE] border-2 border-[#FA0000] text-[#FA0000] font-bold";

                  let style =
                    "bg-gray-100 border-gray-400 text-gray-700"; // not visited

                  if (q.status === "not_answered")
                    style = "bg-red-100 border-red-500 text-red-600";

                  if (q.status === "answered")
                    style = "bg-green-100 border-green-500 text-green-700";

                  if (
                    q.status === "marked" ||
                    q.status === "marked_answered"
                  )
                    style = "bg-orange-100 border-orange-500 text-orange-700";

                  if (isCurrent)
                    style += " border-2 border-black font-bold scale-105";


                  return (
                    <div
                      key={q.id}
                      onClick={() => handlePaletteClick(globalIdx)}
                      className={`aspect-square flex items-center justify-center rounded-md border cursor-pointer ${style}`}
                    >
                      {globalIdx + 1}
                    </div>
                  );
                })}
            </div>

            <div className="p-5 border-t">
              <div className="grid grid-cols-2 gap-3 mb-5 text-[14px]">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-gray-400"></div>
                  Not Visited
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-red-400"></div>
                  Not Answered
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-green-500"></div>
                  Answered
                </div>

                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 bg-orange-400"></div>
                  Review
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    const currentSectionId = currentQ.sectionId;
                    const rows = getSectionStats(currentSectionId);

                    setSubmitRows(rows);
                    setSubmitTitle(`Submit Section - ${currentQ.sectionName}`);
                    setShowSubmitModal(true);
                  }}

                  className="flex-1 bg-[#21C11E] text-white py-2 rounded-[6px] flex items-center justify-center gap-2"
                >
                  <FiUpload /> Section
                </button>
                <button
                  onClick={() => {
                    const rows = getSectionStats();
                    setSubmitRows(rows);
                    setSubmitTitle("Submit Full Test");
                    setShowSubmitModal(true);
                  }}
                  className="flex-1 bg-[#21C11E] text-white py-2 rounded-[6px] flex items-center justify-center gap-2"
                >
                  <FiCheckCircle /> Test
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestInterface;
